export class AddedMergeCondition {
    public id!: string
    public value!: string
}